export default "__VITE_ASSET__Cmowo6F3__"